module.exports = __webpack_public_path__ + "img/766554_C1BEBB_2A1A0E_B4ABAC-256px.183b50ed.png";